import React, { useState } from 'react';
import '../App.css';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { addToWaitlist } from '../lib/waitlist';

const WaitlistModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        email: '',
        firstName: '',
        lastName: '',
        userType: '',
        additionalInfo: '',
        companyName: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (error) setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess(false);
        setLoading(true);

        // Validate required fields
        if (!formData.email || !formData.firstName || !formData.lastName || !formData.userType) {
            setError('Please fill in all required fields');
            setLoading(false);
            return;
        }

        try {
            const result = await addToWaitlist(formData);
            
            if (result.success) {
                setSuccess(true);
                // Reset form
                setFormData({
                    email: '',
                    firstName: '',
                    lastName: '',
                    userType: '',
                    additionalInfo: '',
                    companyName: '',
                });
                // Close modal after 2 seconds
                setTimeout(() => {
                    onClose();
                    setSuccess(false);
                }, 2000);
            } else {
                setError(result.error || 'Failed to add to waitlist');
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                <div className="modal-header">
                    <h2>Join the Waitlist</h2>
                    <button className="modal-close" onClick={onClose} aria-label="Close">
                        ×
                    </button>
                </div>
                <div className="modal-body">
                    {success ? (
                        <div style={{ textAlign: 'center', padding: '2rem' }}>
                            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
                            <h3 style={{ marginBottom: '0.5rem' }}>Thank you!</h3>
                            <p>You've been successfully added to the waitlist.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                <div>
                                    <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                        Email <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Input
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        placeholder="your.email@example.com"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="firstName" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                        First Name <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Input
                                        id="firstName"
                                        name="firstName"
                                        type="text"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                        placeholder="John"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="lastName" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                        Last Name <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Input
                                        id="lastName"
                                        name="lastName"
                                        type="text"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                        placeholder="Doe"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="userType" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                        I am a... <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <select
                                        id="userType"
                                        name="userType"
                                        value={formData.userType}
                                        onChange={handleChange}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '0.5rem',
                                            borderRadius: '0.375rem',
                                            border: '1px solid #d1d5db',
                                            fontSize: '0.875rem',
                                        }}
                                    >
                                        <option value="">Select...</option>
                                        <option value="BUYER">Buyer</option>
                                        <option value="SUPPLIER">Supplier</option>
                                    </select>
                                </div>

                                <div>
                                    <label htmlFor="companyName" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                        Company Name
                                    </label>
                                    <Input
                                        id="companyName"
                                        name="companyName"
                                        type="text"
                                        value={formData.companyName}
                                        onChange={handleChange}
                                        placeholder="Acme Corp"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="additionalInfo" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                        Additional Info?
                                    </label>
                                    <textarea
                                        id="additionalInfo"
                                        name="additionalInfo"
                                        value={formData.additionalInfo}
                                        onChange={handleChange}
                                        placeholder="Tell us more about what you're looking for..."
                                        rows={4}
                                        style={{
                                            width: '100%',
                                            padding: '0.5rem',
                                            borderRadius: '0.375rem',
                                            border: '1px solid #d1d5db',
                                            fontSize: '0.875rem',
                                            fontFamily: 'inherit',
                                            resize: 'vertical',
                                        }}
                                    />
                                </div>

                                {error && (
                                    <div style={{ 
                                        padding: '0.75rem', 
                                        backgroundColor: '#fee2e2', 
                                        color: '#991b1b', 
                                        borderRadius: '0.375rem',
                                        fontSize: '0.875rem'
                                    }}>
                                        {error}
                                    </div>
                                )}

                                <Button type="submit" disabled={loading} style={{ marginTop: '0.5rem' }}>
                                    {loading ? 'Submitting...' : 'Join Waitlist'}
                                </Button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WaitlistModal;
